<template>
  <v-container id="login" class="fill-height justify-center" tag="section">
    <v-row justify="center">
      <v-slide-y-transition appear>
        <v-card light max-width="100%" width="400" class="px-5 py-3">
          <template #heading>
            <div class="text-center">
              <h1 class="display-2 font-weight-bold mb-2">
                {{ $t('login.title') }}
              </h1>
            </div>
          </template>

          <v-card-title>
            {{ this.$t('login.title') }}
          </v-card-title>

          <v-card-text class="text-center">
            <!-- <div class="text-center grey--text body-1 font-weight-light">
              Or Be Classical
            </div>

            <v-text-field
              color="secondary"
              label="First Name..."
              prepend-icon="mdi-face"
              class="mt-10"
            /> --->
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
              @submit="submitHandler"
            >
              <v-text-field
                v-model="email"
                color="secondary"
                :label="$t('login.email.label')"
                prepend-icon="mdi-email"
                :rules="emailRules"
              />

              <v-text-field
                v-model="password"
                color="secondary"
                :label="$t('login.password.label')"
                type="password"
                prepend-icon="mdi-lock-outline"
                :rules="passwordRules"
              />
              <v-progress-linear
                v-if="loadingData"
                color="primary"
                indeterminate
              />
              <div v-if="errorMessage" class="red--text body-2 text-left px-8">
                {{ errorMessage }}
              </div>

              <v-row class="mt-8 justify-start align-center">
                <pages-btn
                  large
                  color=""
                  depressed
                  type="submit"
                  :disabled="!valid"
                  class="v-btn--text primary--text"
                >
                  {{ $t('login.login_button_text') }}
                </pages-btn>
                <router-link
                  class="login__forgot-password-link"
                  :to="{ name: 'ForgotPassword', params: { email } }"
                  >{{ $t('login.forgot_password') }}</router-link
                >
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-slide-y-transition>
    </v-row>
  </v-container>
</template>

<script>
import { login } from '@/shared/api/index.ts'
import {
  defineComponent,
  reactive,
  toRefs,
  ref,
  onBeforeMount,
} from '@vue/composition-api'
import { AuthenticationError } from '@/shared/api'

export default defineComponent({
  name: 'PagesLogin',
  components: {
    PagesBtn: () => import('./components/Btn'),
  },
  setup(props, context) {
    const data = reactive({
      valid: true,
      password: '',
      passwordRules: [
        (v) =>
          (!!v && v.length >= 8) ||
          context.root.$t('login.password.invalid_length'),
        (v) => {
          const result = v.match(/^.*(?=\S*[\W]).*$/)
          return (
            (result && result.length && result[0] !== '') ||
            context.root.$t('login.password.specialCharacter')
          )
        },
      ],
      email: '',
      emailRules: [
        (v) => !!v || context.root.$t('login.email.required'),
        (v) => /.+@.+\..+/.test(v) || context.root.$t('login.email.invalid'),
      ],
    })
    const errorMessage = ref('')

    const form = ref(null)
    const loadingData = ref(false)

    const submitHandler = async (event) => {
      event.preventDefault()
      event.stopPropagation()
      form.value.validate()
      if (!data.valid) {
        return
      }
      loadingData.value = true
      errorMessage.value = ''
      try {
        await login(data.email, data.password)
        loadingData.value = false
        context.root.$router.push({ path: '/' })
      } catch (e) {
        loadingData.value = false
        errorMessage.value =
          e instanceof AuthenticationError
            ? context.root.$t('login.invalidCredentials')
            : context.root.$t('login.unknownError')
      }
    }

    onBeforeMount(() => {
      if (context.root.$route.params.email) {
        data.email = context.root.$route.params.email
      }
    })

    return {
      ...toRefs(data),
      form,
      loadingData,
      submitHandler,
      errorMessage,
    }
  },
})
</script>
<style lang="scss">
.login__forgot-password-link {
  font-size: 12px;
}
</style>
